export default "__VITE_ASSET__Bct2jkS0__"